<button
  [type]="buttonType"
  [disabled]="disabled"
  class="button {{ buttonClass }} next-btn-text"
>
  <span>Next</span>
  <img
    [src]="
      disabled
        ? '../assets/icons/ic-arrow-right-1-grey@3x.svg'
        : '../assets/icons/ic-arrow-right-1-white@3x.svg'
    "
    alt=""
  />
</button>
